import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import EmployeeTable from "./components/EmployeeTable";
import Layout from "../../components/layout/Layout";

const Employees = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Helper to extract filters from current URL search params
  const getFiltersFromUrl = (params) => ({
    search: params.get("search") || "",
    department: params.get("department") || "",
    branch: params.get("branch") || "",
    company: params.get("company") || "",
    status: params.get("status") || "",
    assignmentType: params.get("assignmentType") || "",
    // From the dashboard's "Hired in the last 90 days" tile
    hiredFrom: params.get("hiredFrom") || "",
  });

  // 1. Initialize filters directly from the current URL on load
  const [filters, setFilters] = useState(() => getFiltersFromUrl(searchParams));

  // 2. Synchronize whenever searchParams change (handling browser back/forward navigation)
  useEffect(() => {
    const newFilters = getFiltersFromUrl(searchParams);
    setFilters(newFilters);
  }, [searchParams]);

  // 3. Wrapper function to update both state and the URL query string together
  const handleFilterChange = (updater) => {
    const nextFilters =
      typeof updater === "function" ? updater(filters) : updater;
    setFilters(nextFilters);

    // Build new URL search parameters, omitting empty or "All" values
    const newParams = {};
    Object.keys(nextFilters).forEach((key) => {
      const val = nextFilters[key];
      if (
        val !== undefined &&
        val !== null &&
        String(val).trim() !== "" &&
        val !== "All"
      ) {
        newParams[key] = val;
      }
    });

    // Pass replace: false to ensure proper history stack entry
    setSearchParams(newParams, { replace: false });
  };

  return (
    <Layout>
      <div className="container-fluid py-4 px-lg-4">
        <EmployeeTable filters={filters} setFilters={handleFilterChange} />
      </div>
    </Layout>
  );
};

export default Employees;
